import React, { useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IonContent, IonPage, IonHeader, IonFooter, IonLoading, 
        IonGrid, IonCol, IonRow, IonImg, IonAlert } from '@ionic/react';
import { EnumSecurityObject, EnumSecurityAction, EnumSecurityLevel } from '../domain/enums'; 
import { IClient, IClientList } from '../domain/Client';
import { Plugins } from '@capacitor/core';
import { authenticateUserAsync, getAuthorizedClients, getActivityLogByIdAsync } from '../services/asyncDataService';
import { loadLists } from '../services/utils';
import { LoginParams } from '../domain/MobileApp';
import { IActivityLogResult_Response } from '../domain/ActivityLog';
import './css/Login.css';

const { Network } = Plugins;

const ExternalLogin: React.FC<RouteComponentProps> = ({match, history, location}) => { 
    const _username = (match.params as LoginParams).usr;
    const _clientId = (match.params as LoginParams).cId;
    const _id = (match.params as LoginParams).id || 0;
    const _permitId = (match.params as LoginParams).permitId || 0;
    const _mooringId = (match.params as LoginParams).mooringId || 0;
    const _personId = (match.params as LoginParams).personId || 0;
    const _boatId = (match.params as LoginParams).boatId || 0;

    const _password = "externalloginfrommobile";

    const [showLoading, setShowLoading] = useState(false);
    const [showPopupRights, setShowPopupRights] = useState(false);
    const [showPopupNoConnection, setShowPopupNoConnection] = useState(false);
    const [isVisible, setIsVisisble] = useState(false);
    const [myException, setMyException] = useState("");
    const [, setIsOnline] = useState<boolean>(window.localStorage.getItem("online") !== "0");
    
    useEffect(() => {
        //window.resizeTo(250,250); 
        Network.addListener("networkStatusChange", status => {
          setIsOnline(status.connected);
          if (status.connected)
            window.localStorage.setItem("online", "1");
          else
            window.localStorage.setItem("online", "0");
        });

        if (_username && _password && _clientId) {
            loginProcess(_username, _password, _clientId);
        }
    
        return () => Network.removeAllListeners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const loadClientListAsync = async(token:string|null) => {
        const expectedData = await getAuthorizedClients(String(token),
                    EnumSecurityObject.Berth.toString(),
                    EnumSecurityAction.View.toString(),
                    EnumSecurityLevel.Filtered.toString());
        if (expectedData) {
            let clients = (JSON.parse(expectedData.toString()) as IClientList).Clients;
            window.localStorage.setItem("clients", JSON.stringify(clients));
            if (clients.length === 0) {
                window.localStorage.setItem("defaultClient", "-1");
                return [];
            }
            else {
                window.localStorage.setItem("defaultClient", clients[0].ClientID.toString());
                window.localStorage.setItem("defaultClientName", clients[0].ClientName.toString());
                
                return clients; 
            }
        }
        else {
            return [];
        }
    }

    const setLoginStorage = (token:string, expirationDate: string, username:string, password:string) => {
        window.localStorage.setItem("token", token);
        window.localStorage.setItem("expireTokenDate", expirationDate);
        window.localStorage.setItem("username", username);
        window.localStorage.setItem("password", password);
    }

    const login = async() => {
        if (String(window.localStorage.getItem("defaultClient")) !== "-1") {
            loadLists(window.localStorage.getItem("token"), String(window.localStorage.getItem("username")));
               
            let _clients = JSON.parse(String(window.localStorage.getItem("clients"))) as IClient[];
            let filteredClient = _clients.find((x) => x.ClientID.toString() === String(window.localStorage.getItem("defaultClient")));
            if (filteredClient){
                window.localStorage.setItem("defaultClientName", filteredClient.ClientName.toString());
            } 
                 
            if (_id && _id !== '0') {  // no add(_id != 0), even view the list (_id == -1) or edit (_id)  
                if (_id === '-1') {
                    setTimeout(() => { history.push('/home');}, 5000); //go to the list 
                } 
                else {
                    let expectedData = await getActivityLogByIdAsync(String(window.localStorage.getItem("token")), _id);
                    if (expectedData && expectedData.data) {
                        let activityLogItem = JSON.parse(expectedData.data.toString()) as IActivityLogResult_Response;
                        if (activityLogItem) {
                            setTimeout(() => {
                                history.push('/activity/'+ _id + '/' 
                                    + _clientId 
                                    + '/' + activityLogItem.Result.ActivityLogEntryTypeID.toString() 
                                    +'/1'
                                    + '/' + _permitId 
                                    + '/' + _mooringId
                                    + '/' + _personId
                                    + '/' + _boatId);
                            }, 5000);
                        }
                        else {
                            history.push('/login'); 
                        } 
                    }
                    else {
                        history.push('/login');
                    }
                }
            }
            else { //add
                setTimeout(() => {
                    history.push('/externalHome/' 
                        + String(window.localStorage.getItem("defaultClient")) 
                        + '/' + _permitId 
                        + '/' + _mooringId
                        + '/' + _personId
                        + '/' + _boatId); 
                }, 5000);
            }
        }
        else 
            history.push('/login'); 
    }

    const loginProcess = async(username:string, password:string, clientId:string) => {
        if (isVisible)
            return;
        let data = {
            username: username,
            password: password,
            grant_type: "password"
        };
        setShowLoading(true);
        if (username === String(window.localStorage.getItem("username")) && password === String(window.localStorage.getItem("password"))) { //there is a stored username and a stored password
            if (window.localStorage.getItem("token") && window.localStorage.getItem("expireTokenDate")) { //there is a token stored and a token expired date
                let storedToken = window.localStorage.getItem("token");
                let expireTokenDate = new Date(String(window.localStorage.getItem("expireTokenDate")));
                if (expireTokenDate < new Date()) { //token has expired            
                    let expectedData = await authenticateUserAsync(data);
                    if (expectedData && (expectedData as any).access_token) { //no error in authentication
                        let myToken = (expectedData as any).access_token;
                        let expirationDate = (expectedData as any)[".expires"];
                        setLoginStorage(myToken, expirationDate, data.username, data.password);
                        try {
                            let _returnedClients = await loadClientListAsync(myToken);
                            setIsVisisble(true);
                            setShowLoading(false);
                            if (_returnedClients.length === 1) {
                                window.localStorage.setItem("defaultClient", _returnedClients[0].ClientID?.toString());
                            }
                            else {
                                window.localStorage.setItem("defaultClient", clientId);
                            }
                            login();

                        }
                        catch (ex) { //error on loading client list
                            setMyException("Details: " + (ex as any).toString());
                            setShowLoading(false);
                            setShowPopupRights(true);
                        }
                    }
                    else if ((expectedData as any)?.error === "invalid_grant"){ // error "invalid_grant" in authentication 
                        window.localStorage.setItem("defaultClient", "-1");
                        setMyException("Details: invalid_grant");
                        setShowLoading(false);
                        setShowPopupRights(true);
                    }
                    else {
                        window.localStorage.setItem("defaultClient", "-1"); // error in authentication 
                        setMyException("Details: " + (expectedData as any)?.error);
                        setShowLoading(false);
                        setShowPopupNoConnection(true);
                    }
                } 
                else { //token is good
                    try {
                        let _returnedClients = await loadClientListAsync(storedToken);
                        setIsVisisble(true);
                        setShowLoading(false);
                        if (_returnedClients.length === 1) {
                            window.localStorage.setItem("defaultClient", _returnedClients[0].ClientID?.toString());
                        }
                        else {
                            window.localStorage.setItem("defaultClient", clientId);
                        }
                        login();
                    }
                    catch (ex) { //error on loading client list
                        setMyException("Details: " + (ex as any).toString());
                        setShowLoading(false);
                        setShowPopupRights(true);
                    }
                }
            }
            else { //there is no token stored or a token expired date
                let expectedData = await authenticateUserAsync(data);
                if (expectedData && (expectedData as any).access_token) { //no error in authentication
                    let myToken = (expectedData as any).access_token;
                    let expirationDate = (expectedData as any)[".expires"];
                    setLoginStorage(myToken, expirationDate, data.username, data.password);
                    try {
                        let _returnedClients = await loadClientListAsync(myToken);
                        setIsVisisble(true);
                        setShowLoading(false);
                        if (_returnedClients.length === 1) {
                            window.localStorage.setItem("defaultClient", _returnedClients[0].ClientID?.toString());
                        }
                        else {
                            window.localStorage.setItem("defaultClient", clientId);
                        }
                        login();
                    }
                    catch (ex) { //error on loading client list
                        setMyException("Details: " + (ex as any).toString());
                        setShowLoading(false);
                        setShowPopupRights(true);
                    }
                }
                else if ((expectedData as any)?.error === "invalid_grant"){ // error "invalid_grant" in authentication 
                    window.localStorage.setItem("defaultClient", "-1");
                    setMyException("Details: invalid_grant");
                    setShowLoading(false);
                    setShowPopupRights(true);
                }
                else {
                    window.localStorage.setItem("defaultClient", "-1"); // error in authentication 
                    setMyException("Details: " + (expectedData as any)?.error);
                    setShowLoading(false);
                    setShowPopupNoConnection(true);
                }
            }
        }
        else { //there is no stored username or a stored password
            let expectedData = await authenticateUserAsync(data);
            if (expectedData && (expectedData as any).access_token) { //no error in authentication
                let myToken = (expectedData as any).access_token;
                let expirationDate = (expectedData as any)[".expires"];
                setLoginStorage(myToken, expirationDate, data.username, data.password);
                try {
                    let _returnedClients = await loadClientListAsync(myToken);
                    setIsVisisble(true);
                    setShowLoading(false);
                    if (_returnedClients.length === 1) {
                        window.localStorage.setItem("defaultClient", _returnedClients[0].ClientID?.toString());
                    }
                    else {
                        window.localStorage.setItem("defaultClient", clientId);
                    }
                    login();
                }
                catch (ex) { //error on loading client list
                    setMyException("Details: " + (ex as any).toString());
                    setShowLoading(false);
                    setShowPopupRights(true);
                }
            }
            else if ((expectedData as any)?.error === "invalid_grant") { // error "invalid_grant" in authentication
                window.localStorage.setItem("defaultClient", "-1");
                setMyException("Details: invalid_grant");
                setShowLoading(false);
                setShowPopupRights(true);
            }
            else { // error in authentication 
                window.localStorage.setItem("defaultClient", "-1");
                setMyException("Details: " + (expectedData as any)?.error);
                setShowLoading(false);
                setShowPopupNoConnection(true);
            } 
        }
    }
    
    return (
        <IonPage>
            <IonHeader mode="ios"></IonHeader>  
            <IonContent class="login-ion-content">
                <IonGrid>
                    <IonRow class="my-first-row">
                        <IonCol></IonCol>
                    </IonRow>
                    <IonRow>
                        <IonCol size="1" size-sm></IonCol>
                        <IonCol>
                            <IonImg src={"assets/images/logoBigNoBack.png"} />
                        </IonCol>
                        <IonCol size="1" size-sm></IonCol>
                    </IonRow>
                    <IonRow class="my-second-row">
                        <IonCol></IonCol>
                    </IonRow>
                </IonGrid>
                <IonLoading mode="ios"
                    cssClass='my-loading'
                    isOpen={showLoading}
                    onDidDismiss={() => setShowLoading(false)}
                    message={'Getting data...'}
                />   
                <IonAlert mode="ios"
                    isOpen={showPopupRights}
                    onDidDismiss={() => setShowPopupRights(false)}
                    cssClass='my-custom-class'
                    header={'Alert'}
                    subHeader={myException}
                    message={'You do not have rights to use this app.'}
                    buttons={['OK']}
                /> 
                <IonAlert mode="ios"
                    isOpen={showPopupNoConnection}
                    onDidDismiss={() => setShowPopupNoConnection(false)}
                    cssClass='my-custom-class'
                    header={'Alert'}
                    subHeader={myException}
                    message={'You do not have a connection to the database.'}
                    buttons={['OK']}
                /> 
            </IonContent>
            <IonFooter mode="ios"></IonFooter>
        </IonPage>
    )
};

export default ExternalLogin;
  